import { render, staticRenderFns } from "./assessments-list-icon.vue?vue&type=template&id=488dac49"
import script from "./assessments-list-icon.vue?vue&type=script&lang=js"
export * from "./assessments-list-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports